import { render, staticRenderFns } from "./AnnualInspectionsList.vue?vue&type=template&id=705ef634"
import script from "./AnnualInspectionsList.vue?vue&type=script&lang=js"
export * from "./AnnualInspectionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports